import { useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react'
import ReactDOM from 'react-dom'
import OutsideClickComponent from '../../fragments/OutsideClickComponent'
import { isLightColor } from '../../../lib/script'
import { useCanEdit, useUserTabEditPermissionDisabled, useCanEditArchived } from '../../../lib/usersPermissions'

import classes from './CustomSelect.module.css'
import BodySimpleModal from '../modal/BodySimpleModal'
import { isInsidePortalModal } from '../../../lib/overlayLayers'

export default function CustomSelectGrouped({name, label, optionsData, preSelectedValue, action, identifier, sameSizeAsContainer, minWidth, reverseDrawer, rtlDrawer, bkTransparent, borderRed, hasRemove, noticeDisabled, isDisabled, thin_select, fixedDrawer = true, undetermined}) {
    // let masterDisable = useCanEdit()
    let editArchivedDisabled = useCanEditArchived()
    let userPermissionDisabled = useUserTabEditPermissionDisabled(identifier?.type)
    
    const containerRef = useRef(null)
    const inputRef = useRef(null)
    const drawerRef = useRef(null)
    const [coordinates, setCoordinates] = useState({
        top: null,
        left: null,
        width: null
    })


    const [showDrawer, setShowDrawer] = useState(false)
    const [selectedHidden, setSelectedHidden] = useState(false)
    const [inputValue, setInputValue] = useState('')
    const [selectedValue, setSelectedValue] = useState(null)
    const [bkColor, setBkColor] = useState(null)
    const [textColor, setTextColor] = useState(null)

    const [options, setOptions] = useState(optionsData)

    function changeInputhandler(event) {
        if (!userPermissionDisabled) {
            setInputValue(event.target.value ? event.target.value : '')
            // let arr = []
            const query = (event.target.value ?? '').toString().toLowerCase()
            let arr = optionsData.map(element => {
                return {...element, options: element.options.filter(item => item.label.toString().toLowerCase().includes(query))}
            })
            setOptions(arr) 
        } 
    }
    function inputBlurHandle() {
        setInputValue('')
    }

    const updateFixedDrawerCoordinates = useCallback(() => {
        if (!containerRef.current) {
            return
        }
        const rect = containerRef.current.getBoundingClientRect()
        const left = rect.left
        const width = rect.width
        const top = rect.top
        const bottom = rect.bottom
        const windowHeight = window.innerHeight

        if (windowHeight - bottom < 300) {
            setCoordinates({
                bottom: windowHeight - top + 8,
                left,
                width,
                top: 'unset',
            })
        } else {
            setCoordinates({
                top: bottom + 4,
                left,
                width,
                bottom: undefined,
            })
        }
    }, [])

    function focusHandler() {
        if (!userPermissionDisabled) {
            setShowDrawer(true) // show drawer on focus
            setSelectedHidden(true) //if there is a selected value, need to set it hidden

            if (fixedDrawer) {
                updateFixedDrawerCoordinates()
            }
        }        
    }

    useLayoutEffect(() => {
        if (showDrawer && fixedDrawer) {
            updateFixedDrawerCoordinates()
        }
    }, [showDrawer, fixedDrawer, updateFixedDrawerCoordinates])
    function blurHandler() {
        setShowDrawer(false)
        setSelectedHidden(false)
        setOptions(optionsData) // clear the filters
    }

    const justToggledClosedByMouseDownRef = useRef(false)

    function focusSelectOnClickHandler() {
        if (userPermissionDisabled) return
        // mousedown handler may have just closed the drawer for this same click;
        // skip the click so we don't immediately reopen it.
        if (justToggledClosedByMouseDownRef.current) {
            justToggledClosedByMouseDownRef.current = false
            return
        }
        if (showDrawer) return
        setShowDrawer(true)
        setSelectedHidden(true)
        if (fixedDrawer) {
            updateFixedDrawerCoordinates()
        }
        if (inputRef && inputRef.current) {
            inputRef.current.focus()
        }
    }

    function toggleOnMouseDownHandler(event) {
        if (userPermissionDisabled) return
        if (showDrawer) {
            // Closing: prevent the input from being (re)focused, which would
            // otherwise re-open the drawer via onFocus before the click fires.
            event.preventDefault()
            justToggledClosedByMouseDownRef.current = true
            blurHandler()
            inputRef.current?.blur()
        }
    } 

    function setOptionHandler(item) {
        if (!userPermissionDisabled) {
            setInputValue('') //clear input
            setShowDrawer(false) //close drawer
            setSelectedHidden(false) //show the selected value
            setOptions(optionsData) // clear the filters

            if (!action || sameSizeAsContainer) { // if no action, like in forms, need to set the item by itself
                setSelectedValue(item)
            }
        
            if (action) {
                action({
                    data: {
                        value: item.value
                    },
                    identifier: identifier,
                    option: item
                })
            }
        }
    }

    function setOptionHandlerEffect(item) {
        setInputValue('') //clear input
        setSelectedValue(item) //set value
        setShowDrawer(false) //close drawer
        setSelectedHidden(false) //show the selected value
        setOptions(optionsData) // clear the filters       
    }


    function clearSelectionHandler() {
        if (!userPermissionDisabled) {
            if (selectedValue) {
                setInputValue('') //clear input
                setShowDrawer(false) //close drawer
                setSelectedHidden(false) //show the selected value
                setOptions(optionsData) // clear the filters
            
                setSelectedValue(null)
            
                if (action) {
                    action({
                        data: {
                            value: null
                        },
                        identifier: identifier
                    })
                }
            }
        }
    }

    useEffect(() => {
        if (optionsData ) { //&& preSelectedValue
            setOptions(optionsData)

            let allOptions = []

            optionsData.forEach(element => {
                if (element && element.options) {
                    allOptions = [...allOptions, ...element.options]
                }
            });
            

            let foundOption = allOptions.find(item => item.value == preSelectedValue)

            if (foundOption) {
                setOptionHandlerEffect(foundOption)

                if (foundOption.color_code) {
                    setBkColor(foundOption.color_code)
                    let lightDark = isLightColor(foundOption.color_code)
                    // setIsLight(lightDark)
                    setTextColor(lightDark ? 'var(--text)' : 'var(--white)')
                    
                } else {
                    setTextColor(null)
                    setBkColor(null)
                    // setNoBorder(false)
                }
            } else {
                setSelectedValue(null)
            }
     
            
        } else {
            setInputValue('') //clear input
            setShowDrawer(false) //close drawer
            setSelectedHidden(false) //show the selected value        
            setSelectedValue(null)
            setTextColor(null)
            setBkColor(null)
        }
    }, [optionsData, preSelectedValue])

    useEffect(() => {
        if (!showDrawer) {
            return
        }

        const onScrollOrResize = () => {
            if (fixedDrawer) {
                updateFixedDrawerCoordinates()
                return
            }
            blurHandler()
            inputBlurHandle()
            inputRef.current?.blur()
        }

        document.addEventListener('scroll', onScrollOrResize, true)
        window.addEventListener('resize', onScrollOrResize, { passive: true })
        return () => {
            document.removeEventListener('scroll', onScrollOrResize, true)
            window.removeEventListener('resize', onScrollOrResize)
        }
    }, [showDrawer, fixedDrawer, blurHandler, updateFixedDrawerCoordinates])

    const outsideClickExtraInsideRefs = useMemo(() => fixedDrawer ? [drawerRef] : undefined, [fixedDrawer])

    if (!optionsData) { // no options were sent
        return <div className={`${classes.container}`} style={{minWidth: minWidth ? minWidth : ''}}>
            <OutsideClickComponent task={blurHandler}>
                
                <div className={classes.input_container}>
                    {label && <span className={classes.label}>{label}</span>}
                    <input name={name + '_no_options'} type='text' className={classes.input} autoComplete="off" onChange={() => {}} value={inputValue ? inputValue : ''}/>
                    <div className={classes.selected}>No data available</div>
                    <div className={`select_pointer ${classes.pointer}`}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                            <path d="M4.5 6.75L9 11.25L13.5 6.75" stroke="#577988" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </div>
                </div>
            </OutsideClickComponent>
        </div>
    }

    const insideModal = fixedDrawer && isInsidePortalModal(containerRef.current)

    const drawerNode = showDrawer ? (
        <div
            ref={drawerRef}
            className={`${classes.drawer} ${(reverseDrawer && !fixedDrawer) ? classes.reverse_drawer : ''} ${rtlDrawer ? classes.rtl_drawer : ''} ${fixedDrawer ? classes.fixed : ''} ${insideModal ? classes.fixed_above_modal : ''}`}
            style={{ top: coordinates.top, left: coordinates.left, width: coordinates.width, bottom: coordinates.bottom }}
        >
            {options && options.filter(item => (item.options && item.options.length > 0)).map(item => (
                <div key={item.label}>
                    <p className={classes.group_label}>{item.label}</p>
                    {item.options && item.options.map(opt => (
                        <div key={opt.value}>
                            <button type="button" onClick={setOptionHandler.bind(this, opt)} className={`${classes.option} ${(selectedValue && (selectedValue.value == opt.value)) ? classes.option_selected : ''}`} disabled={opt.manual_selection}>{opt.label}</button>
                        </div>
                    ))}
                </div>
            ))}
        </div>
    ) : null

    const overlayRoot = typeof document !== 'undefined' ? document.getElementById('overlay-root') : null

    return <div className={`${classes.container} ${(showDrawer || (selectedValue || undetermined)) ? classes.is_focused : ''} ${!label && classes.no_label_container} ${thin_select ? classes.thin_select : ''} ${sameSizeAsContainer ? classes.same_size_as_container : ''} ${isDisabled || editArchivedDisabled || userPermissionDisabled ? classes.is_inactive : ''}`} style={{minWidth: minWidth ? minWidth : ''}}>
        <OutsideClickComponent task={blurHandler} extraInsideRefs={outsideClickExtraInsideRefs}>
            <div ref={containerRef} onMouseDown={toggleOnMouseDownHandler} onClick={focusSelectOnClickHandler} className={`${classes.input_container} ${hasRemove ? classes.has_remove_button : ''} ${(selectedValue && selectedValue.color) && 'bk_' + selectedValue.color.split(' ').join('_')} ${bkTransparent ? classes.background_transparent: ''} ${borderRed ? classes.border_red : ''}`} style={{backgroundColor: bkColor, color: textColor}}>
                {label && <div className={`${classes.label} label`} style={{color: textColor}}>{label}</div>}
                <input ref={inputRef} type='text' onChange={changeInputhandler} onFocus={focusHandler} onBlur={inputBlurHandle} className={classes.input} value={inputValue ? inputValue : ''} autoComplete="off" title={selectedValue?.label}/>
                <input name={name} type='hidden' value={selectedValue?.value ? selectedValue?.value : ''} autoComplete="off" />

                {selectedValue && <div className={classes.selected_shadow} style={{opacity: 0}}>{selectedValue.label}</div>}
                {selectedValue && <div className={`${classes.selected} selected`} style={{opacity: selectedHidden ? 0 : 1, color: textColor}} >{selectedValue.label}</div>}

                {undetermined && <div className={classes.selected_shadow} style={{opacity: 0}}>{undetermined}</div>}
                {undetermined && <div className={`${classes.selected} selected`} style={{opacity: selectedHidden ? 0 : 1, color: textColor}}>{undetermined}</div>}
                <div className={`select_pointer ${classes.pointer} ${showDrawer && classes.opened}`}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                        <path d="M4.5 6.75L9 11.25L13.5 6.75" stroke="#577988" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </div>
                {hasRemove && <button className={`${classes.clear_select} custom_select_clear_button`} onClick={clearSelectionHandler}><i className='ti ti-x'></i></button>}
            </div>
            {fixedDrawer
                ? (drawerNode && overlayRoot && ReactDOM.createPortal(drawerNode, overlayRoot))
                : drawerNode}
        </OutsideClickComponent>

        <BodySimpleModal isDisabled={isDisabled} messages={noticeDisabled}/>
    </div>
}